import React, { Suspense } from 'react';
import { Route } from 'react-router-dom';
import LoadingSpinner from '../components/ui/LoadingSpinner';

const UserAccount = React.lazy(() => import('../pages/UserAccount'));
const SellerProfile = React.lazy(() => import('../pages/SellerProfile'));
const Bookmarks = React.lazy(() => import('../pages/BaoBookmarks'));

const SuspenseWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <Suspense fallback={<div className="flex justify-center items-center min-h-screen"><LoadingSpinner size="lg" color="orange" /></div>}>
    {children}
  </Suspense>
);

export const dashboardRoutes = (
  <>
    <Route path="/account" element={<SuspenseWrapper><UserAccount /></SuspenseWrapper>} />
    <Route path="/bookmarks" element={<SuspenseWrapper><Bookmarks /></SuspenseWrapper>} />
    <Route path="/seller/:sellerId" element={<SuspenseWrapper><SellerProfile /></SuspenseWrapper>} />
  </>
);